import FJConfig from '../config/FJConfig';
import { FJDecoderManager, FJEncoderManager } from '@fj/codec';

let _isInit = false;

function init() {
    if (_isInit) return;
    _isInit = true;

    const basePath = `${FJConfig.LIB_PATH}codec/${FJConfig.CODEC_VERSION}/`;
    const wasmPath = `${FJConfig.LIB_PATH}/wasm/${FJConfig.WASM_VERSION}/`;
    const encoderWorkerPath = `${basePath}/encoder.worker.js`;
    const decoderWorkerPath = `${basePath}/decoder.worker.js`;
    const audioProcessorWorkerPath = `${basePath}/audio-processor.worker.js`;
    const webcodecWorkerPath = `${basePath}/webcodec.worker.js`;

    FJEncoderManager.init(encoderWorkerPath, webcodecWorkerPath, wasmPath, `${wasmPath}codec.js`);
    FJDecoderManager.init(decoderWorkerPath, wasmPath, `${wasmPath}codec.js`, audioProcessorWorkerPath);
}

export default { init };
